import { useMemo } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import useTravelerPickerErrorHandler, {
  ErrorHandlerSelectedData,
} from "./hooks";
import { SelectEmployeeFormValues } from "./SelectEmployeeDrawer/types";
import { SelectNonEmployeeFormValues } from "./SelectNonEmployeeDrawer/types";
import { Employee, FlightNonEmployee, HotelNonEmployee } from "./types";

type UsedFormValues = Partial<
  Pick<SelectEmployeeFormValues, "selectedEmployees"> &
    SelectNonEmployeeFormValues
>;

type Props = UseFormReturn<any> & {
  name: Array<keyof UsedFormValues>;
};

export default function TravelerPickerErrorHandler(props: Props) {
  const { control, name, ...methods } = props;

  const values = useWatch({ control, name });
  const data: ErrorHandlerSelectedData = useMemo(() => {
    const data: ErrorHandlerSelectedData = {
      nonEmployees: {} as FlightNonEmployee & HotelNonEmployee,
    };

    name.forEach((key, index) => {
      switch (key as keyof UsedFormValues) {
        case "selectedEmployees":
          data.employees = (values[index] || []) as Employee[];
          break;
        case "adults":
          data.nonEmployees!.adults = (values[index] || 0) as number;
          break;
        case "children":
          data.nonEmployees!.children = (values[index] || 0) as number;
          break;
        case "infants":
          data.nonEmployees!.infants = (values[index] || 0) as number;
          break;
        case "childrenAges":
          data.nonEmployees!.childrenAges = (values[index] || []) as number[];
          break;
        default:
          break;
      }
    });
    return data;
  }, [values, name]);

  useTravelerPickerErrorHandler(data, { ...methods, control });
  return null;
}
